/** Edge simon-says flag evaluation. Used outside local `next dev`. */
export const SIMON_SAYS_FLAGS_URL =
  'https://external.api.tranquility.ai/simon-says/v1/flags/evaluate';

/**
 * Local simon-says (docker-compose, host port 8002). Selected when a local
 * env file sets ``SIMON_SAYS=local``.
 */
export const TAI_FEATURE_FLAGS_HTTP_URL = 'http://localhost:8002/simon-says/v1/flags/evaluate';

/** How often the browser re-posts the flags URL while Simon Says is on. */
export const SIMON_SAYS_POLL_INTERVAL_MS = 60_000;

/**
 * Flags endpoint. Deployed runs always use the edge evaluate route.
 * Local `next dev` uses ``SIMON_SAYS`` from the env file: ``local`` is the
 * docker-compose instance, and any other value is that URL. Read this on the
 * server: the browser bundle does not see the env var.
 */
export function simonSaysFlagsUrl(
  env: { SIMON_SAYS?: string; NODE_ENV?: string } = process.env,
): string {
  const runningLocally = env.NODE_ENV !== 'production';
  const override = env.SIMON_SAYS?.trim();
  if (!runningLocally || !override) return SIMON_SAYS_FLAGS_URL;
  if (override.toLowerCase() === 'local') return TAI_FEATURE_FLAGS_HTTP_URL;
  return override;
}
